'use strict';

var compareByDepth = require('./compare-by-depth.cjs');
var array = require('../../../../../../../motion-utils/dist/es/array.cjs');

class FlatTree {
    constructor() {
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        array.addUniqueItem(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        array.removeItem(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort(compareByDepth.compareByDepth);
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

exports.FlatTree = FlatTree;
//# sourceMappingURL=flat-tree.cjs.map
